module.exports = __webpack_public_path__ + "static/media/1ton-variant-3.62c8dc98.jpg";